<template>
  <transition name="fade-in-up">
    <router-view></router-view>
  </transition>
</template>

<script>
export default {
  name: 'ProductionUnitManagement',
}
</script>

<style lang="css" scoped>

</style>